import { Routes } from '@angular/router';

import { DashboardComponent } from './components/dashboard/dashboard.component';
import { PromptCreateComponent } from './components/prompt-create/prompt-create.component';
import { UserpromptComponent } from './components/user-prompt-screen/user-prompt.component';
import { LoginComponent } from './components/login/login.component';
import { HomeComponent } from './components/home/home.component';
import { AuthGuard } from './authguard/authguard';
import { UserManualAndTutorialComponent } from './components/user-manual-and-tutorial/user-manual-and-tutorial.component';
import { MyGptComponent } from './components/my-gpt/my-gpt.component';
import { SubmitFeedbackComponent } from './components/submit-feedback/submit-feedback.component';
import { CategoryManagementComponent } from './components/admin-components/category-management/category-management.component';
import { ModelConfigurationMgmtComponent } from './components/admin-components/model-configuration-mgmt/model-configuration-mgmt.component';
import { CallbackComponent } from './components/callback/callback.component';
import { SsoComponent } from './components/sso/sso.component';
import { PromptManagementComponent } from './components/admin-components/prompt-management/prompt-management.component';
import { UserManagementComponent } from './components/admin-components/user-management/user-management.component';
import { GamificationBoardComponent } from './gamification-board/gamification-board.component';
import { AdminAuthGuard } from './authguard/admin.guard';
import { UserAuthGuard } from './authguard/user.guard';



export const routes: Routes = [
    { path: '', redirectTo: '/login', pathMatch: 'full' },
     { path: 'login-ind', component: LoginComponent },
    { path: 'login', component: SsoComponent },

    { path: 'sso-auth/callback', component: CallbackComponent },

    {
        path: 'home', component: HomeComponent, canActivate: [AuthGuard],
        children: [
            { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
            {
                path: 'dashboard', component: DashboardComponent,
            },
            { path: 'user-prompt', component: UserpromptComponent },
            { path: 'prompt-create', component: PromptCreateComponent, canActivate: [UserAuthGuard]},
            {path:'user-manual' ,component:UserManualAndTutorialComponent},
            {path:'submit-feedback' ,component:SubmitFeedbackComponent},
            {path:'my-gpt' ,component:MyGptComponent},
            { path: 'category-management', component: CategoryManagementComponent, canActivate: [AdminAuthGuard] },
            { path: 'model-configuration', component: ModelConfigurationMgmtComponent, canActivate: [AdminAuthGuard] },
            { path: 'prompt-configuration', component: PromptManagementComponent, canActivate: [AdminAuthGuard] },
            { path: 'user-configuration', component: UserManagementComponent, canActivate: [AdminAuthGuard] },
            { path: 'gamification-board', component: GamificationBoardComponent },
        ]
    },
   
   
    // { path: '**', component: LoginComponent },
    // { path: '**', component: SsoComponent },
    { path: '**', redirectTo: 'home' },
    
];
